import axios from "axios";
import { handleHeader } from "components/Datos Personales/Convenios/functionsConvenios";
import { handle_error } from "components/DirectivoUnidad/Vacaciones/helper_function";
import { UserData } from "components/Sidebar/Sidebar_Principal";
import configData from "../config.json";

const URL_UPDATE_FECHAULTIMOCAMBIO = "FormularioController/ActualizarFechaActualizacion"
const URL_UPDATE_FECHACONFIRMACION_ACTUALIZACION_DP = "FormularioController/ActualizarFechaConfirmacionDatosActualizados"

export function isNullUndefinedOrEmpty(valor:any){
    return valor === undefined || valor === null || valor === ""
}



export async function UpdateDateUltimoCambioDatosGenerales (tokenUser:string){
    var statusCode = 0;
    try {
        const respuesta = await axios.put(configData.SERVER_URL + URL_UPDATE_FECHAULTIMOCAMBIO,{},
            {headers:handleHeader(tokenUser)}
        )  
        statusCode= respuesta.status;
    } catch (error) {
        var error_any:any = error;
        statusCode = handle_error(error_any);
    }
   
    return statusCode;

}

export async function UpdateDateFechaConfirmacionActualizacionDatosGenerales (tokenUser:string){
    var statusCode = 0;
    try {
        const respuesta = await axios.put(configData.SERVER_URL + URL_UPDATE_FECHACONFIRMACION_ACTUALIZACION_DP,{},
            {headers:handleHeader(tokenUser)}
        )  
        statusCode= respuesta.status;
    } catch (error) {
        var error_any:any = error;
        statusCode = handle_error(error_any);
    }
   
    return statusCode;

}